import {
  FilterMode,
  TenantPlanCreateMutationVariables,
  TenantPlan_OrderBy,
  TenantPlan,
  SortOrder,
  TenantPlan_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { fieldByLang } from "../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const tenantPlanService = {
  createOne: buildCreateOne(
    (tenantPlanCreateVariables: TenantPlanCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.tenantPlanCreate(tenantPlanCreateVariables);
        return result.tenantPlanCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantPlanOne({ id });
    return result.tenantPlanOne as TenantPlan;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    language: string = "es",
    orderBy: TenantPlan_OrderBy[] | null = null,
    filter: TenantPlan_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantPlan_Filter | undefined;
    if (searchValue !== "") {
      where = {
        [fieldByLang("name", language)]: {
          contains: searchValue,
          mode: FilterMode.Insensitive,
        },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantPlanListWithOffset({
      offset,
      take,
      orderBy: orderBy
        ? orderBy
        : [{ [fieldByLang("name", language)]: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantPlanListWithOffset
    ) as TenantPlan[];
    return { list, orderBy };
  },
};
